<template>
  <h1 class="text-[30px] font-thin text-white">Profile</h1>
  <ProfileSettings />
</template>

<script>
import ProfileSettings from '@features/account/ProfileSettings.vue';

export default {
  components: {
    ProfileSettings,
  },
};
</script>
